<template>
  
  <header>
      <nav class="" id="vy_header ">
        <h1 v-on:click="home" style="cursor:pointer"><img id="by-logo" src="../../../images/logo.png" alt="ボラ活エール" /></h1>
      </nav>
      <div style="text-align: left;">
        <table class="vy-search-form-table-nav">
        <!--
              政令都市向けオプション適用時は表示する事前集会の制限機能を表示するかチェック
              １：政令都市向けオプション未適用の場合は制限なし
              ２：政令都市向けオプション適用済みかつ管理者の場合は制限なし
              ３：政令都市向けオプション適用済みかつ利用者の場合はチェックボックスを表示
              -->
              <template v-if="GlobalData.designated_city">
                <template v-if="GlobalData.kengen == 'Shakyouser' || GlobalData.kengen == 'shakyouser'">
                <tr>
                  <th>
                    <label for="shakyouser_set" style="color:red">担当以外も表示</label>
                  </th>
                  <td style="text-align: left;">
                  
                    
                    <select class="form-control" name="shakyouser_set" id="shakyouser_set" v-model="shakyouser_set" v-on:change="Check()" >
                      <option value=2>する</option>
                      <option value=1>しない</option>
                    </select>
                    
                  </td>
                </tr>
                </template>
              </template>

          <!-- 施設名 -->
          <tr>
            <th>
              <label for="facility_name">受入先名</label>
            </th>
            <td style="text-align: left;">
              <input type="text" placeholder="受入先名" class="form-control" id="facility_name0" name="facility_name0" v-model="facility_name0"
              v-on:change="Check()" 
              @keyup.enter.prevent="Check"/>
            </td>
          </tr>
          
          <!-- 住所 -->
          <tr>
            <th>
              <label for="address">住所</label>
            </th>
            <td style="text-align: left;">
              <input type="text"  class="form-control" id="address0" name="address0"  v-model="address0"
              v-on:change="Check()" 
              @keyup.enter.prevent="Check"/>
            </td>
          </tr>
          
          <!-- 電話番号 -->
          <tr>
            <th>
              <label for="tel">電話番号</label>
            </th>
            <td style="text-align: left;">
              <input type="text"  class="form-control" id="tel0" name="tel0"  v-model="tel0"
              v-on:change="Check()" 
              @keyup.enter.prevent="Check"/>
            </td>
          </tr>
          
          <!-- FAX番号 -->
          <tr>
            <th>
              <label for="fax">FAX番号</label>
            </th>
            <td style="text-align: left;">
              <input type="text"  class="form-control" id="fax0" name="fax0"  v-model="fax0"
              v-on:change="Check()" 
              @keyup.enter.prevent="Check"/>
            </td>
          </tr>
          
          <!-- Eメールアドレス -->
          <tr>
            <th>
              <label for="email">Eメールアドレス</label>
            </th>
            <td style="text-align: left;">
              <input type="text"  class="form-control" id="email0" name="email0"  v-model="email0"
              v-on:change="Check()" 
              @keyup.enter.prevent="Check"/>
            </td>
          </tr>
          
          <!-- 担当者名 -->
          <tr>
            <th>
              <label for="staff_name">担当者名</label>
            </th>
            <td style="text-align: left;">
              <input type="text"  class="form-control" id="staff_name0" name="staff_name0"  v-model="staff_name0"
              v-on:change="Check()" 
              @keyup.enter.prevent="Check"/>
            </td>
          </tr>

          <tr>
            <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>

          <!-- フリーワード -->
          <tr>
            <th>
              <label for="keyword">フリーワード</label>
            </th>
            <td style="text-align: left;">
              <input type="text" class="form-control" id="keyword" name="keyword" placeholder="コメント、備考" v-model="keyword0"  
                v-on:change="Check()"
                @keyup.enter.prevent="Check"
                maxlength="100"/>
            </td>
          </tr>
        </table>
      </div>
    </header>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import { GlobalData } from '../../js/userdata_shakyo.js'

const props = defineProps(['param']);

const router = useRouter();
let route = useRoute()

const cityname = route.params.shakyo
//------------------------------ リンク --------------------------------
const home = function() {
    router.push('/'+cityname+'/Kanri')
}

//検索条件
let facility_name0 = ref(props.param.facility_name)
let address0 = ref(props.param.facility_jusyo)
let tel0 = ref(props.param.facility_tel)
let fax0 = ref(props.param.facility_fax)
let email0 = ref(props.param.facility_email)
let staff_name0 = ref(props.param.facility_tantou)
let keyword0 = ref(props.param.facility_comment)
let shakyouser_set = ref(1)
if(props.param.shakyouser_set){
  shakyouser_set.value = props.param.shakyouser_set
}

/* 親コンポーネントに関わる関数 */
const emit = defineEmits(['call'])
    
let Check = function(){  //検索を開始する

    //  検索開始の合図とともに検索条件を送信する
    emit('call',{cmd:'search',
                facility_name:facility_name0.value,
                facility_jusyo:address0.value,
                facility_tel:tel0.value,
                facility_fax:fax0.value,
                facility_email:email0.value,
                facility_tantou:staff_name0.value,
                keyword:keyword0.value,
                shakyouser_set:shakyouser_set.value});
}

</script>
